const map = {
	"./ArrowLineDown.svg": 19916,
	"./BgVendor.svg": 54296,
	"./Bill.svg": 92032,
	"./BillBlue.svg": 29180,
	"./Booking.svg": 15628,
	"./BookingBlue.svg": 41504,
	"./BookingReportCard.svg": 99244,
	"./CAR.svg": 56999,
	"./Calendar.svg": 54321,
	"./Calender.svg": 38533,
	"./CallLogo.svg": 99342,
	"./CarProfile.svg": 89106,
	"./Charger.svg": 31343,
	"./CheckSquare.svg": 97604,
	"./Clock.svg": 94195,
	"./Compliance.svg": 37522,
	"./ComplianceBlue.svg": 47914,
	"./ComplianceConfig.svg": 20624,
	"./ComplianceConfigBlue.svg": 39948,
	"./CompnayTop.svg": 74243,
	"./ConfigVehicle.svg": 75779,
	"./ConfigVehicleBlue.svg": 63171,
	"./Configure.svg": 61189,
	"./Confirm.svg": 78601,
	"./CouponWhite.svg": 69208,
	"./CrossBtn.svg": 98831,
	"./Dashboard.svg": 46317,
	"./DashboardBlue.svg": 21833,
	"./DownloadBlue.svg": 7639,
	"./DownloadSimple.svg": 77565,
	"./Driver.svg": 13065,
	"./DriverBlue.svg": 96221,
	"./DutyType.svg": 67759,
	"./Edit.svg": 38599,
	"./EditIcon.svg": 80200,
	"./EditIconGrey.svg": 15873,
	"./EnvelopeSimple.svg": 92993,
	"./FAQ.svg": 92109,
	"./FAQBlue.svg": 40393,
	"./FeedbackConfig.svg": 89984,
	"./FeedbackConfigBlue.svg": 5692,
	"./FileUpload.svg": 47566,
	"./FilterIcon.svg": 90598,
	"./Group 1000003955.svg": 4781,
	"./Link.svg": 62135,
	"./LinkSimple.svg": 16757,
	"./LiveTracking.svg": 69762,
	"./LiveTrackingBlue.svg": 61338,
	"./Logo.png": 55926,
	"./Logout.svg": 29501,
	"./LogoutBlue.svg": 84409,
	"./MailLogo.svg": 45599,
	"./NewsPaper.svg": 35652,
	"./NoCarImg.svg": 15101,
	"./Notification.svg": 92830,
	"./NotificationBlue.svg": 64334,
	"./Office.svg": 86671,
	"./OfficeBlue.svg": 15351,
	"./OfficeGrey.svg": 42738,
	"./OfficeLogo.svg": 90918,
	"./Operation.svg": 19670,
	"./OperationBlue.svg": 65494,
	"./Payment.svg": 48375,
	"./PaymentBlue.svg": 8591,
	"./Preview.svg": 38433,
	"./PrintDuty.svg": 37096,
	"./ProfileVendor.svg": 63056,
	"./RateCard.svg": 92103,
	"./RateCardBlue.svg": 26623,
	"./RatingStar.svg": 54116,
	"./Reallot.svg": 20180,
	"./Reservation.svg": 54719,
	"./ReservationBlue.svg": 7495,
	"./Revenue.svg": 24325,
	"./RevenueBlue.svg": 85489,
	"./Setting.svg": 87069,
	"./SettingBlue.svg": 87321,
	"./SignOutLogo.svg": 57153,
	"./Snack.svg": 90267,
	"./Star.svg": 91895,
	"./SubVendorLogo.svg": 89152,
	"./Taxi.png": 68127,
	"./TollCharge.svg": 45724,
	"./TollChargeBlue.svg": 40752,
	"./UploadIcon.svg": 93003,
	"./UserLogo.svg": 48195,
	"./Vehicle.svg": 3817,
	"./VehicleBlue.svg": 72509,
	"./VendorBlue.svg": 13401,
	"./Warning.svg": 22265,
	"./WaterBottle.svg": 96092,
	"./Wifi.svg": 75932,
	"./active.svg": 45577,
	"./assignDriver.svg": 8730,
	"./assignDriverBlue.svg": 37762,
	"./assignVehicle.svg": 21328,
	"./assignVehicleBlue.svg": 77036,
	"./blackVehicle.svg": 30184,
	"./block.svg": 68058,
	"./blueCar.svg": 86567,
	"./blueLogo.svg": 38186,
	"./bookingCount.svg": 97745,
	"./bookingImg.svg": 28609,
	"./camera.svg": 8286,
	"./car-engine.svg": 24014,
	"./car-parts.svg": 36526,
	"./carWheel.svg": 53044,
	"./carplaceholder.jpg": 69022,
	"./checklist.svg": 29217,
	"./clapping.svg": 57697,
	"./cloudArrowUp.svg": 51422,
	"./coin.svg": 75792,
	"./companyDetailsCar.svg": 35096,
	"./companyDetailsRevenue.svg": 93090,
	"./companyLogo.svg": 66325,
	"./complaint.svg": 41498,
	"./complaintBlue.svg": 65922,
	"./copy.svg": 65072,
	"./corporateCustomer.svg": 52856,
	"./couponBlue.svg": 8249,
	"./cross.svg": 58045,
	"./customerCall.svg": 54835,
	"./deActivate.svg": 23237,
	"./delete.svg": 10154,
	"./dispatch.svg": 72813,
	"./dispatchBlue.svg": 26729,
	"./dlImg.svg": 71832,
	"./doc.svg": 5227,
	"./download.png": 25651,
	"./drop.svg": 90208,
	"./dropPin.png": 48023,
	"./favicon.ico": 30804,
	"./filter.svg": 14969,
	"./fire-extinguisher.svg": 76629,
	"./first-aid-kit.svg": 64089,
	"./gauge.svg": 12924,
	"./info.svg": 79339,
	"./labelIcon.svg": 32076,
	"./liveIcon.svg": 7878,
	"./locationLogo.svg": 50767,
	"./lockicon.svg": 92081,
	"./login_bg.svg": 50972,
	"./login_hand.png": 66434,
	"./mapImage.svg": 63606,
	"./mechanical.svg": 98594,
	"./meter.svg": 98106,
	"./mobile_bg.svg": 88197,
	"./moreDetailsLocation.svg": 29539,
	"./moreEditIcon.svg": 97683,
	"./notificationIcon.svg": 43773,
	"./originPin.png": 48552,
	"./otp_bg.svg": 11348,
	"./pageNotFound.svg": 93059,
	"./pause.svg": 87235,
	"./paymentSelect.svg": 83247,
	"./pdf.svg": 2443,
	"./pdfImg.svg": 5416,
	"./performance.svg": 2763,
	"./pickUp.svg": 66315,
	"./profileImg.svg": 1643,
	"./regionalUser.svg": 23429,
	"./regionalUserActive.svg": 80899,
	"./reportActive.svg": 73651,
	"./reportInActive.svg": 63738,
	"./revenueImg.svg": 53970,
	"./searchIcon.svg": 58592,
	"./smLocation.svg": 99550,
	"./smLocationIcon.svg": 75901,
	"./smStar.svg": 31623,
	"./tick.svg": 39104,
	"./tickmark.svg": 12091,
	"./transiction.svg": 9965,
	"./transictionActive.svg": 80027,
	"./upgrade.svg": 561,
	"./vendor.svg": 27709,
	"./wallet.svg": 65544,
	"./whiteCar.svg": 72436,
	"./whiteFilter.svg": 212
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;